import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { useEffect, useState } from "react";

import { useFilters } from "../Filters.hook";
import { formatMoney } from "@Utils/Functions";
import { validateRange } from "src/utils/Functions";

const FRAGMENT_SURFACERANGE_OPTIONS = new FragmentDefiner(
	"Filter",
	`
		id
		name
		options
	`
);

export const FRAGMENT_SURFACERANGE = new FragmentDefiner(
	"Filters",
	`
		surfaceRange {
		${FRAGMENT_SURFACERANGE_OPTIONS.query()}
		}
	`
);
export interface SurfaceRangeFilterProps {
	filterChanged?: ({}: any) => void;
	collapsable?: boolean;
	labeled?: boolean;
	triggerApplyFilter?: Function
}

export const useSurfaceRange = ({ filterChanged, triggerApplyFilter }: SurfaceRangeFilterProps) => {
	const {
		filters,
	} = useFilters();

	const [min, setMin] = useState<string | null>(filters?.m2Min);
	const [max, setMax] = useState<string | null>(filters?.m2Max);
	const [m2, setM2] = useState<string | null>(filters?.m2Type);
    const [errorMessage, setErrorMessage] = useState<string>('')

	useEffect(() => setMin(filters?.m2Min), [filters?.m2Min]);
	useEffect(() => setMax(filters?.m2Max), [filters?.m2Max]);
	useEffect(() => setM2(filters?.m2Type), [filters?.m2Type]);

	useEffect(() => {
		if (min || max) setSurfaceFilter();
	}, [m2]);

	const setSurfaceFilter = () => {
		const thereIsMin = min && min !== "";
		const thereIsMax = max && max !== "";

		handleApplyFilter({
			m2Min: thereIsMin ? {text: "Desde" + " " + formatMoney(min) + " m²", value: Number(min)} : null,
			m2Max: thereIsMax ? {text: "Hasta" + " " + formatMoney(max) + " m²", value: Number(max)} : null,
			m2Type: (thereIsMin || thereIsMax) ? { text: undefined, value: m2 } : null,
		});

        setErrorMessage(validateRange(min, max, 'El m² mínimo no puede ser mayor al m² máximo'))
	};

	const cleanSurfaceFilter = (type) => {
		handleApplyFilter({
			[type]: null
		})
	}

	const handleApplyFilter = (filter) => {
        if (triggerApplyFilter) triggerApplyFilter(filter);
        else filterChanged(filter)
    }

	return {
		m2Min: { value: min, set: setMin },
		m2Max: { value: max, set: setMax },
		m2Type: { value: m2, set: setM2 },
		saveFilter: setSurfaceFilter,
		cleanSurfaceFilter: cleanSurfaceFilter,
		isActive: filters?.m2Min != null || filters?.m2Max != null,
		errorMessage
	};
};
